import Grid from "@mui/material/Grid2";
import { useState } from "react";
import { ChatWindow } from "@/components/broadcast";
import { ChatList } from "./list";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import { CreateButton } from "@refinedev/mui";
import { AddCommentOutlined } from "@mui/icons-material";
import { useList } from "@refinedev/core";
import { useSearchParams } from "react-router";

export const BroadcastPage = () => {
  const [searchParams] = useSearchParams();
  const selectedChatIdFromQuery = searchParams.get("selectedChatId");

  const { data: broadcasts } = useList({
    resource: "rooms/broadcasts",
  });

  // Instead of using selectedChatId as state, we'll only store user selections in state
  const [userSelectedChatId, setUserSelectedChatId] = useState<string | null>(null);
  
  // Derive the effective selected chat ID directly in the render path
  // This ensures predictable behavior regardless of when data loads
  const selectedChatId = userSelectedChatId || 
                         selectedChatIdFromQuery || 
                         (broadcasts?.data?.[broadcasts.data.length - 1]?.id ? String(broadcasts.data[broadcasts.data.length - 1].id) : null);
  
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  return (
    <Box
      sx={{
        height: "calc(100vh - 150px)", // Account for header and other UI elements
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Grid container columns={24} sx={{ flex: 1, minHeight: 0 }}>
        {/* Chat List Section - 1/3 of the page */}
        <Grid
          size={{
            xs: 8,
            sm: 8,
            md: 8,
            lg: 8,
            xl: 8,
          }}
          sx={{
            height: "100%",
            overflow: "auto",
          }}
        >
          <Stack direction="column" sx={{ height: "100%", backgroundColor: "background.paper", border: `1px solid ${theme.palette.divider}` }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ paddingInline: 2, height: 95, borderBottom: `1px solid ${theme.palette.divider}` }}>
              <Typography variant="h6">Broadcasts</Typography>
              <CreateButton hideText size="small" sx={{ height: "30px", '&:hover': { color: theme.palette.primary.dark } }} variant="text" svgIconProps={{
                component: AddCommentOutlined,
                sx: {
                  fontSize: "24px"
                }
              }}/>
            </Stack>
            <ChatList onChatSelect={setUserSelectedChatId} selectedChatIds={[selectedChatId || ""]}/>
          </Stack>
        </Grid>

        {/* Chat Window Section - 2/3 of the page */}
        <Grid
          size={{
            xs: 16,
            sm: 16,
            md: 16,
            lg: 16,
            xl: 16,
          }}
          sx={{
            height: "100%",
            overflow: "auto",
            backgroundColor: "background.paper",
          }}
        >
          {selectedChatId ? (
            <ChatWindow 
              chatId={selectedChatId} 
              onChatDeleted={() => setUserSelectedChatId(null)}
            />
          ) : (
            <Typography variant="h6" style={{
              display: "flex",
              height: "100%",
              alignItems: "center",
              justifyContent: "center",
              color: "text.secondary",
              backgroundColor: isDarkMode ? theme.palette.grey[900] : theme.palette.grey[50],
              border: `1px solid ${theme.palette.divider}`,
              borderLeft: 'none',
            }}>
              Select a chat to view messages
            </Typography>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};